import { SimpleTooltip } from "@hulahoop/ui";
import type { ReactElement } from "react";

export function IconTooltip({ label, children }: { label: string; children: ReactElement }) {
  return <SimpleTooltip label={label}>{children}</SimpleTooltip>;
}
